function getHasConnectedListingPortal(portals) {
  return portals.some(portal => portal.connected)
}

export function getListingPortalsHintKey({
  hasPortalsError,
  hasSchedule,
  isLoading,
  portals,
  selectedPortals,
}) {
  if (isLoading || hasPortalsError) {
    return null
  }

  if (!getHasConnectedListingPortal(portals)) {
    return 'RentalPortal.ListingFormPublishNoPortalsKey'
  }

  if (selectedPortals.length === 0) {
    return 'RentalPortal.ListingFormPublishNotAdvertisedHintKey'
  }

  return hasSchedule
    ? 'RentalPortal.ListingFormPublishScheduledHintKey'
    : 'RentalPortal.ListingFormPublishImmediateHintKey'
}

export function getToggledListingPortals({ isChecked, portal, portals }) {
  return isChecked
    ? [...portals, portal]
    : portals.filter(item => item !== portal)
}

export function getListingPortalRowTooltip({ disabledReason, portal, t }) {
  if (disabledReason) {
    return disabledReason
  }

  if (!portal.connected) {
    return t('RentalPortal.ListingFormPublishNotConnectedKey')
  }
}

export function getIsListingPortalLocked({ disabled, isChecked, portal }) {
  return disabled || (!portal.connected && !isChecked)
}
